import {
    emailMarketing,
    IEspClient,
    SailthruClient,
    SAILTHRU_USER_LISTS,
    SAILTHRU_USER_LIST_ACTIONS,
} from '@omaze/email-marketing';
import { AnyAction } from '@reduxjs/toolkit';
import { ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { createSignUpEmailCaptureErrorAction } from '../actions/sign-up-email-capture-error';
import { isSignUpEmailCaptureStartAction } from '../actions/sign-up-email-capture-start';
import { createSignUpEmailCaptureSuccessAction } from '../actions/sign-up-email-capture-success';
import { ErrorType } from '../email-capture.state';

export function* signUpEmailCaptureSaga (action: AnyAction): Iterator<any> {
    const sailthruClient: IEspClient = SailthruClient.get({
        apiURL: window.ozShopifyApp.dataSources.sailthru.api,
        customerID: window.ozShopifyApp.dataSources.sailthru.customerId || '',
    });

    const espClient: IEspClient = emailMarketing(sailthruClient);

    try {
        yield espClient.addOrUpdateUser({
            email: action.payload,
            userLists: {
                [SAILTHRU_USER_LISTS.MASTER_LIST]: SAILTHRU_USER_LIST_ACTIONS.ADD,
                [SAILTHRU_USER_LISTS.EVERGREEN_LIST]: SAILTHRU_USER_LIST_ACTIONS.ADD,
            },
            onError: function (): never {
                throw new Error(ErrorType.SAILTHRU);
            },
        });

        yield put(createSignUpEmailCaptureSuccessAction());
    } catch (error) {
        yield put(createSignUpEmailCaptureErrorAction());
    }
}

export function* watchSignUpEmailCapture (): Iterator<ForkEffect> {
    yield takeEvery(isSignUpEmailCaptureStartAction, signUpEmailCaptureSaga);
}
